<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Checkout' | titlecase}}</h2>
                <p>
                    Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<section class="error-section mt-5 mb-3">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <img src="../../../../assets/img/home2/error.jpg" class="itemImage" width="220" alt="error">
                <p class="errorParagraph">"Oops! Something went wrong with your order."</p>
                <p class="errorSubtext">Please try again or contact support if the problem persists.</p>
                
                <div class="action-buttons mt-4">
                    <a href="cart" class="btn btn-primary me-3">Try Again</a>
                </div>
                
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>